import Button from "@mui/material/Button";
import { muiTheme } from "@/styles/theme";

interface CustomIconButtonProps {
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
  icon: React.ReactNode;
  disabled?: boolean;
}

const CustomIconButton = ({
  handleClick,
  icon,
  disabled,
}: CustomIconButtonProps) => {
  return (
    <Button
      variant="contained"
      disabled={disabled}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "36px",
        height: "36px",
        padding: "10px",
        borderRadius: 2,
        border: "1px solid #D0D5DD",
        color: muiTheme.colorSchemes.light.palette.primary[500],
        background: muiTheme.colorSchemes.light.palette.background.white,
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        textTransform: "none",
        "&:hover": {
          background: "#F9FAFB",
          boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        },
        "&:active": {
          boxShadow:
            "0px 0px 0px 4px #F2F4F7, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        },
      }}
      onClick={handleClick}
    >
      {icon}
    </Button>
  );
};

export default CustomIconButton;
